import { render, staticRenderFns } from "./tealist.vue?vue&type=template&id=f270236e&scoped=true&"
import script from "./tealist.vue?vue&type=script&lang=js&"
export * from "./tealist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f270236e",
  null
  
)

export default component.exports